import { foldText } from "./text";

/**
 * Folds a query and splits it into whitespace-separated tokens. An empty result
 * means "match everything" — callers should skip filtering entirely rather than
 * pass it to {@link matchesTokens}.
 */
export function searchTokens(query: string): string[] {
  const folded = foldText(query.trim());
  return folded ? folded.split(/\s+/) : [];
}

/**
 * Every token must match at least one haystack, so tokens can be typed in any
 * order and each may match a different field ("kovacova 12" → name + id).
 *
 * A purely numeric token matches by prefix: ids read left-to-right, so "12"
 * should find patient 1234 but not 512. Every other token matches as a
 * substring. Haystacks must already be folded with {@link foldText} — fold once
 * per row rather than once per keystroke.
 */
export function matchesTokens(haystacks: string[], tokens: string[]): boolean {
  return tokens.every((token) =>
    /^\d+$/.test(token)
      ? haystacks.some((haystack) => haystack.startsWith(token))
      : haystacks.some((haystack) => haystack.includes(token)),
  );
}
